import { request } from '@/shared/api/request'

export const getData = () => request({ url: `contract/universalMethods/laborStandards`, method: 'get' })